import { jsx as _jsx } from "react/jsx-runtime";
import hexagonOrangeUrl from '../../../assets/gems/hexagon_orange.svg?inline';
export function HexagonOrange({ ...props }) {
    return _jsx("img", { ...props, src: hexagonOrangeUrl, alt: 'HexagonOrangeImage' });
}
